module.exports = __webpack_public_path__ + "static/media/food_8.47285d09.jpeg";